import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AlertaMensagemComponent } from '../shared/alerta-mensagem.component';

@Component({
  selector: 'app-layout-terminal',
  standalone: true,
  imports: [CommonModule, AlertaMensagemComponent],
  templateUrl: './layout-terminal.component.html'
})
export class LayoutTerminalComponent {
  @Input() logo = '';
  @Input() iniciais = '';
  @Input() nome = '';
  @Input() agora = new Date();
  @Input() mensagem = '';
}
